import React from 'react';
import './style.scss';
import Wrapper from '../../templates/Wrapper/Wrapper';
import Helmet from 'react-helmet';
import { TranslatableText } from '../../providers/LanguageProvider';
//import MobileOrderBanner from '../../components/MobileOrderBanner/MobileOrderBanner';
import { NavLink } from 'react-router-dom';
import Icon from '../../components/Icon/Icon';
import { trackGAEvent } from '../../shared/helpers';
// IMAGES
import heroOrderEN from './i/hero-order-en.png';
import heroOrderFR from './i/hero-order-fr.png';
//import heroOrderEN from './i/hero-order-2024-en.jpg';
//import heroOrderFR from './i/hero-order-2024-fr.jpg';
//import heroOrderMobileEN from './i/hero-order-en.png';
//import heroOrderMobileFR from './i/hero-order-fr.png';

// import ordering1 from './i/ordering-1.jpg';
// import ordering2 from './i/ordering-2.jpg';
// import ordering3 from './i/ordering-3.jpg';

// import ordering1FR from './i/ordering-1_fr.jpg';
// import ordering2FR from './i/ordering-2_fr.jpg';
// import ordering3FR from './i/ordering-3_fr.jpg';

import appStore from './i/app-store-download.png';
import googleStore from './i/google-store-download.png';
import appStoreFR from './i/app-store-download-fr.png';
import googleStoreFR from './i/google-store-download-fr.png';

import appIcon from './i/icon-en.png';
import appIconFr from './i/icon-fr.png';
// import coffeeBanner from './i/free-coffee-tout.jpg';
// import coffeeBannerFr from './i/free-coffee-tout-fr.jpg';
// import coffeeBannerMobile from './i/free-coffee-tout-mobile.jpg';
// import coffeeBannerMobileFr from './i/free-coffee-tout-mobile-fr.jpg';

import rewardsLogoEn from './i/aw-rewards-en.png';
import rewardsLogoFr from './i/aw-rewards-fr.png';
import bearEn from './i/bear-en.png';
import bearFr from './i/bear-fr.png';
import arrow from '../../assets/images/hero-arrow.png';
import blobsDt from './i/blobs-dt-en.png';
import blobsMb from './i/blobs-mb-en.png';
import phone1en from './i/phone-en.png';
import phone1fr from './i/phone-fr.png';
import phone2en from './i/phone2-en.png';
import phone2fr from './i/phone2-fr.png';
import food from './i/food.png';
import one from './i/1.png';
import two from './i/2.png';
import three from './i/3.png';

var currentYear = new Date().getFullYear();
// var randomPhotoArrayEN = [
//   ordering1,
//   ordering2,
//   ordering3,
// ];

// var randomPhotoArrayFR = [
//   ordering1FR,
//   ordering2FR,
//   ordering3FR,
// ];

// var randomPhotoEN = randomPhotoArrayEN[Math.floor(Math.random()*randomPhotoArrayEN.length)];
// var randomPhotoFR = randomPhotoArrayFR[Math.floor(Math.random()*randomPhotoArrayFR.length)];

class Order extends React.Component {

  componentDidMount = () => {
    window.scroll(0,0);
}

  render() {
    return (
    <Wrapper {...this.props} addClass="order">
      {this.props.lang !== 'fr' ?
        <Helmet>
            <title>A&W Rewards—Earn points for your favourite menu items</title>
            <meta name="description" content="Download the A&W app and earn points on your purchases to redeem for your favourite menu items. Get rewarded in-restaurant, when you order ahead or with A&W Delivery." />
            <meta name="keywords" content="a&w canada, rewards, home, burger, root beer, onion rings, chicken, breakfast" />
        </Helmet>
      :
        <Helmet>
            <title>Récompenses A&W - accumulez des points sur l’appli.</title>
            <meta name="description" content="Téléchargez l’appli A&W pour accumuler des points à chaque commande et les échanger contre du A&W gratuit. Profitez de vos récompenses comme bon vous semble : en restaurant, à emporter, ou à livrer chez vous." />
            <meta name="keywords" content="a&w Canada, récompenses, accueil, burger, root beer, rondelles d'oignon, poulet, déjeuner" />
        </Helmet>
      }
            <div className="bg-orange white first">
              {this.props.lang === 'en' ?  
                <>
                  {
                    <img className="rewards-logo" alt="A&W Rewards" src={rewardsLogoEn} />
                  }
                </>
                :
                <>
                  {
                    <img className="rewards-logo" alt="Récompenses A&W" src={rewardsLogoFr} />
                  }
                </>
                }
                <div className="welcome inner">
                  {this.props.lang === 'en' ?  
                  <>
                    {
                      <img className="bear" alt="With the A&W App" src={bearEn} />
                    }
                  </>
                  :
                  <>
                    {
                      <img className="bear" alt="Sur l'appli A&W" src={bearFr} />
                    }
                  </>
                  }
                  <div className="copy">
                    <h1>
                      {this.props.lang === 'en' ?  
                      <>
                        Welcome to A&W Rewards
                      </>
                      :
                      <>
                        Bienvenue dans le programme <br />de Récompenses A&W
                      </>
                      }<span><sup>™</sup></span></h1>
                    <h3>
                      <TranslatableText dictionary={{
                          en: "Earn points. Get rewards. Enjoy your favourites.",
                          fr: "Accumulez des points. Obtenez des récompenses. Dégustez." }}>
                      </TranslatableText>
                    </h3>
                    <h3>
                      {this.props.lang === 'en' ?  
                        <>
                        <a href="https://apps.apple.com/ca/app/a-w/id1236416092" className="app-btn" title="" ><img src={appStore} alt="apple store download" /></a>
                        <a href="https://play.google.com/store/apps/details?id=com.myelane2_aw" className="app-btn" title="" ><img src={googleStore} alt="google play download" /></a>
                        </>
                      :
                        <>
                        <a href="https://apps.apple.com/ca/app/a-w/id1236416092" className="app-btn" title="" ><img src={appStoreFR} alt="apple store download" /></a>
                        <a href="https://play.google.com/store/apps/details?id=com.myelane2_aw" className="app-btn"><img src={googleStoreFR} alt="google play download" /></a>
                        </>
                      }
                    </h3>
                    <h1 className="how">
                      <TranslatableText dictionary={{
                          en: "How does it work?",
                          fr: "Comment ça fonctionne?" }}>
                      </TranslatableText>
                    </h1>                    
                    <img src={arrow} className="bounce arrow" alt="arrow button" />
                  </div>
                </div>
            </div>

            <div className="second">
                <div className="twocol">
                  <div className="image">
                  {this.props.lang === 'en' ?  
                    <>
                      {
                        <img className="phone" alt="Sign up" src={phone1en} />
                      }
                    </>
                    :
                    <>
                      {
                        <img className="phone" alt="NSCRIVEZ-VOUS" src={phone1fr} />
                      }
                    </>
                  }
                  </div>
                  <div className="copy">
                    <img src={one} alt="1" className="step" />
                    <h2>
                      <TranslatableText dictionary={{
                          en: "SIGN UP",
                          fr: "INSCRIVEZ-VOUS" }}>
                      </TranslatableText>
                    </h2>
                    <h3>
                      <TranslatableText dictionary={{
                          en: "for A&W Rewards by downloading the app.",
                          fr: "au programme de Récompenses A&W en téléchargeant l’appli." }}>
                      </TranslatableText>
                    </h3>
                    <p>
                      {this.props.lang === 'en' ?  
                        <>
                           Get rewarded the way you want: <span className="no-break">in-restaurant</span>, <br className="desktopOnly" />when you order ahead on mobile or with A&W Delivery.
                        </>
                        :
                        <>
                          Obtenez ensuite des récompenses en restaurant, sur vos commandes à emporter et même lors de la livraison A&W. <span className="no-break">À vous de choisir.</span>
                        </>
                      }
                    </p>
                  </div>
                </div>
            </div>


            <div className="third white bg-orange">
              <div className="twocol">
                <div className="copy">
                  <img src={two} alt="2" className="step" />
                  <h2>
                    <TranslatableText dictionary={{
                        en: "EARN POINTS",
                        fr: "ACCUMULEZ DES POINTS" }}>
                    </TranslatableText>
                  </h2>
                  <p>
                    {this.props.lang === 'en' ?  
                      <>
                        You'll earn 10 points for every $1* you spend using the app. <br className="desktopOnly" />
                        Plus, get access to exclusive deals and offers.
                      </>
                      :
                      <>
                        Obtenez 10 points par <span className='no-break'>1 $</span> dépensé en <br className="desktopOnly" />utilisant l'appli et profitez <span className="no-break">d’offres exclusives.</span>
                      </>
                    }
                  </p>
                </div>
                <div className="image">
                  {this.props.lang === 'en' ?  
                    <>
                      {
                        <img className="phone" alt="Sign up" src={phone2en} />
                      }
                    </>
                    :
                    <>
                      {
                        <img className="phone" alt="NSCRIVEZ-VOUS" src={phone2fr} />
                      }
                    </>
                  }
                </div>
              </div>
            </div>

            <div className="fourth">
                <div className="twocol">
                  <div className="image"></div>
                  <div className="copy">
                    <img src={three} alt="3" className="step" />
                    <h2>
                      {this.props.lang === 'en' ?  
                        <>
                            REDEEM points <br />for FREE A&W!
                        </>
                        :
                        <>
                            ÉCHANGEZ VOS POINTS <br />CONTRE DU A&W GRATUIT
                        </>
                      }
                    </h2>
                    
                    <p>
                      {this.props.lang === 'en' ?  
                        <>
                          Use your points to redeem for treats like the tasty <span className="no-break">Teen Burger™</span>, <br className="desktopOnly" />
                          crispy Onion Rings, a frosty <span className="no-break">A&W Root Beer™</span> <span className="no-break">and so</span> <span className="no-break">much more. </span><br className="desktopOnly" />
                          The more points you earn, the more rewards <span className="no-break">you unlock.</span>
                        </>
                        :
                        <>
                          Échangez vos points contre du A&W gratuit, comme notre savoureux <span className="no-break">Teen Burger™</span>, 
                          nos rondelles d’oignon croustillantes, notre fameuse <span className='no-break'>Root Beer A&W™</span>, <span className="no-break">et bien</span> <span className="no-break">plus encore.</span><br className="desktopOnly" />
                          Plus vous gagnez de points, plus vous accédez à de <span className="no-break">nouvelles récompenses.</span>
                        </>
                      }
                    </p>
                  </div>
                </div>
            </div>

            <div className="fifth">
              <h1>
                <TranslatableText dictionary={{
                    en: "Got questions?",
                    fr: "Vous avez des questions?" }}>
                </TranslatableText>
              </h1>
              <NavLink className="faq-btn" onClick={() => trackGAEvent("Footer Delivery", "Click", "Button")} to={`/${this.props.lang}/faq/rewards`}  title="Read our FAQs">
                <TranslatableText dictionary={{
                    en: "Read our FAQs",
                    fr: "Consultez notre FAQ" }}>
                </TranslatableText>
              &nbsp; <Icon type="gt-inverted" /> 
              </NavLink>

            </div>

            <div className="smallprint">
              <p>
                {this.props.lang === 'en' ?  
                  <>
                    For more details about A&W Rewards, refer to our <NavLink onClick={() => trackGAEvent("Rewards", "Click", "Terms")} to={`/${this.props.lang}/terms`}  title="Terms of Use">Terms of Use</NavLink>.<br />
                    *Points are calculated on order subtotals after discounts and other offer redemptions. Excludes taxes, fees and purchases made on third party platforms.<br />
                    Apple, the Apple logo, iPhone, and iPad are trademarks of Apple Inc., registered in the U.S. and other countries and regions. App Store is a service mark of Apple Inc.<br />
                    Google Play and the Google Play logo are trademarks of Google LLC.
                  </>
                  :
                  <>
                    Pour plus d’informations au sujet des Récompenses A&W, veuillez consulter nos <NavLink onClick={() => trackGAEvent("Rewards", "Click", "Terms")} to={`/${this.props.lang}/terms`}  title="conditions générales d’utilisation">conditions générales d’utilisation</NavLink>.<br />
                    * Les points sont calculés selon le sous-total de chaque commande (après les rabais, offres et autres réductions). Les taxes, les frais et les achats effectués sur une plateforme tierce sont exclus.<br />
                    Apple, le logo Apple, iPhone et iPad sont des marques de commerces d'apple Inc., enregistrées aux États-Unis et dans d'autres pays et régions. App Store est une marque de service d'apple Inc.<br />
                    Google Play sont des marques de commerce de Google LLC. 
                  </>
                }
              </p>
            </div>
    </Wrapper>
    )
  }
}
export default Order;